import { render, staticRenderFns } from "./detailsquizzEleve.vue?vue&type=template&id=9568c6fc&"
import script from "./detailsquizzEleve.vue?vue&type=script&lang=js&"
export * from "./detailsquizzEleve.vue?vue&type=script&lang=js&"
import style0 from "./detailsquizzEleve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports